import { useSyncExternalStore } from "react";
import { canv } from "@/canv/global";
import { HStack } from "@/shared/ui/Stack";
import type { VoteWindow } from "../../VoteWindow";
import style from "./newVoteSwitch.module.css";

function useOneVotePerItem(voteWindow: VoteWindow) {
    return useSyncExternalStore(voteWindow.subscribeOneVotePerItem, voteWindow.getOneVotePerItem);
}

type NewVoteSwitchProps = {
    name: string;
};

export function NewVoteSwitch({ name }: NewVoteSwitchProps) {
    const isOneVotePerItem = useOneVotePerItem(canv.appInterface.voteWindow);

    const handleChange = () => {
        canv.appInterface.voteWindow.setOneVotePerItem(!isOneVotePerItem);
    };

    return (
        <HStack fullWidth justify="between">
            <p className={style.text}>{name}</p>
            <label className="switch">
                <input type="checkbox" checked={isOneVotePerItem} onChange={handleChange} />
                <span className="slider round" />
            </label>
        </HStack>
    );
}
